// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Router from './router.js'
import VueResource from 'vue-resource'
Vue.use(VueResource)

Vue.prototype.baseUrl = 'http://api.media.adyun.com/navigation/'
Vue.prototype.imgUrl = 'http://res1.adyun.com/res1'

/* eslint-disable */
String.prototype.trim = function () {
	return this.replace(/\s|\xA0/g, '')
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: Router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js